import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      {/* Decorative elements */}
      <div className="hero-line-decoration"></div>
      <div className="hero-ellipse"></div>
      <div className="hero-radial-glow"></div>

      <div className="hero-content">
        <p className="hero-subtitle">PRAVASI SNDP YOGAM UK, Bristol</p>

        <div className="hero-quote">
          <span className="quote-open">&ldquo;</span>
          <h1 className="hero-title">One Caste, One Religion, One God For Man</h1>
          <span className="quote-close">&rdquo;</span>
        </div>

        <div className="hero-attribution">
          <span className="hero-line"></span>
          <span className="hero-author">Sree Narayana Guru</span>
        </div>
      </div>

      <div className="hero-image">
        <img
          src="/Sndp/guru.png"
          alt="Sree Narayana Guru"
        />
      </div>

      {/* Bottom ellipse */}
      <div className="hero-bottom-ellipse"></div>
    </section>
  );
};

export default Hero;
